const navigationDe = {
    "menu_editor": "Speisekarte",
    "settings": "Einstellungen",
    "payment_settings": "Zahlungseinstellungen",
    "user_management": "Benutzerverwaltung",
    "logout": "Abmelden",
    "subscription": "Abonnement",
    "new_restaurant": "Neues Restaurant eröffnen",
    "privacy_policy": "Datenschutzrichtlinie",
    "terms_and_conditions": "Geschäftsbedingungen",
    "statistics": "Statistiken",
    "mozrest": "Prüfmanager",
    "signup": "Melden Sie sich an"
};

export default navigationDe;
